import { render, staticRenderFns } from "./ProductNavComponent.vue?vue&type=template&id=c43534bc&scoped=true"
import script from "./ProductNavComponent.vue?vue&type=script&lang=js"
export * from "./ProductNavComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductNavComponent.vue?vue&type=style&index=0&id=c43534bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43534bc",
  null
  
)

export default component.exports